import queryString from 'qs';

export function createYearRangeModels(startYear, endYear, singleYearThreshold) {
  const models = [];
  let decade = Math.floor(startYear / 10) * 10;
  while (decade < singleYearThreshold) {
    models.push({ id: `${decade}s`, name: `${decade}-${decade + 9}`, range: [0, decade + 9] });
    decade += 10;
  }
  let year = singleYearThreshold;
  while (year <= endYear) {
    models.push({ id: year, name: year });
    year += 1;
  }
  console.log(models);
  return models.reverse();
}

export function stateToQuerystring(state) {
  const params = [];

  if (state.activeType && state.activeType.id) {
    params.push(`policy=${state.activeType.id}`);
  }

  if (state.activeYear && state.activeYear.id) {
    params.push(`year=${state.activeYear.id}`);
  }

  if (state.activeRegion && state.activeRegion.id) {
    params.push(`regionzoom=${state.activeRegion.id}`);
  }

  if (state.activeCountry && state.activeCountry.id) {
    params.push(`country=${state.activeCountry.id}`);
  }

  if (state.activePolicyId) {
    params.push(`policyid=${state.activePolicyId}`);
  }

  if (state.preview) {
    params.push(`preview=1`);
  }

  return params.join('&');
}

export function querystringToState(store, yearsCollection, regionCollection, countriesCollection) {
  const params = queryString.parse(window.location.search.replace(/^\?/, ''));
  const state = {};

  state.activeYear = params.year ? yearsCollection.get(params.year) : yearsCollection.getDefault();
  state.activeType = params.policy
    ? store.types.data.get(params.policy)
    : store.types.data.getDefault();
  state.activeRegion = params.regionzoom
    ? regionCollection.get(params.regionzoom)
    : regionCollection.getDefault();
  state.activeCountry = params.country ? countriesCollection.get(params.country) : undefined;
  state.activePolicyId = params.policyid ? parseInt(params.policyid, 10) : undefined;
  state.preview = !!params.preview;

  return state;
}

export function redirectOldPolicyIds(policyTypes) {
  const params = queryString.parse(window.location.search.replace(/^\?/, ''));
  if (!params.policy) {
    return;
  }
  policyTypes.forEach((parentType) => {
    const policyFromOldId = parentType.children.find((type) => type.oldId === params.policy);
    if (policyFromOldId) {
      params.policy = policyFromOldId.id;
      window.location.replace(
        window.location.href.replace(/\?.*/, '') + '?' + queryString.stringify(params)
      );
    }
  });
}
